import groupBy from 'lodash/groupBy';
import uniq from 'lodash/uniq';

import {
  CONCEPT_CREATION_PERIOD,
  CREATIVE_CREATION_PERIOD,
} from 'scenes/SmartRules/SmartRuleForm/CreativesPopulation';
import {
  FILTER_PERIOD,
  FILTER_PAY_TO,
  FILTER_CREATIVE_CONCEPT_CREATION_PERIOD,
  FILTER_CREATIVE_CREATION_PERIOD,
  DIMENSION_CAMPAIGN,
} from 'scenes/Trackers/Tracker/constants';
import { columnsSchema, chartSchema } from 'scenes/Trackers/Tracker/schemas';

const getPeriodFilters = ({ fromDate, payToDate, toDate }) => ({
  [FILTER_PERIOD]: [fromDate, toDate],
  [FILTER_PAY_TO]: payToDate,
});

const getCreativesPeriodFilters = ({
  [CONCEPT_CREATION_PERIOD]: conceptCreationPeriod,
  [CREATIVE_CREATION_PERIOD]: creativeCreationPeriod,
}) => {
  return {
    ...(conceptCreationPeriod
      ? {
          [FILTER_CREATIVE_CONCEPT_CREATION_PERIOD]: [
            conceptCreationPeriod?.fromDate,
            conceptCreationPeriod?.toDate,
          ],
        }
      : {}),
    ...(creativeCreationPeriod
      ? {
          [FILTER_CREATIVE_CREATION_PERIOD]: [
            creativeCreationPeriod?.fromDate,
            creativeCreationPeriod?.toDate,
          ],
        }
      : null),
  };
};

const isNumeric = ({ metricValueType }) =>
  ['Number', 'Currency', 'Percent'].includes(metricValueType);

const getId = ({ id }) => id;

export const getTrackerParams = ({
  affectedDimension,
  affectedSecondaryDimension,
  ...data
}) => {
  const { baseMetrics = [], compareMetrics = [] } = groupBy(
    data.metrics,
    ({ isCompared }) => (isCompared ? 'compareMetrics' : 'baseMetrics')
  );
  const drillPath = [
    {
      id: affectedDimension,
      type: data.target.dimension,
    },
    {
      type: DIMENSION_CAMPAIGN,
    },
  ];

  if (affectedSecondaryDimension) {
    drillPath.push({
      id: affectedSecondaryDimension,
      type: data.target.secondaryDimension,
    });
  }

  const filtersCollection = [
    {
      ...(data.targetDataPeriod
        ? getPeriodFilters(data.targetDataPeriod.period)
        : null),
      ...(data.creativesTargetDataPeriod
        ? getCreativesPeriodFilters(data.creativesTargetDataPeriod)
        : null),
    },
  ];
  const columns = {
    ...columnsSchema.default(),
  };

  columns.order = uniq([
    ...(data.metrics?.map(getId) || []),
    ...(data.actionMetrics?.map(getId) || []),
    ...columns.order,
  ]);

  const chart = {
    ...chartSchema.default(),
  };

  const statuses = []; // = data.target.statuses;

  if (compareMetrics.length > 0) {
    filtersCollection.unshift({
      ...getPeriodFilters(data.targetDataPeriod.comparePeriod),
    });
    //todo creative creation date && concept creation date?

    chart.metrics = uniq(compareMetrics.map(getId));
  } else if (baseMetrics.length > 0) {
    chart.metrics = uniq(baseMetrics.filter(isNumeric).map(getId));
  } else {
    chart.metrics = ['RegActions'];
  }

  return {
    drillPath: drillPath,
    statuses: statuses,
    filtersCollection: filtersCollection,
    columns: columns,
    charts: [chart],
    ready: true,
  };
};
